module.exports = __webpack_public_path__ + "img/13-half-lg.3ba13ece.jpg";